module.exports = __webpack_public_path__ + "img/close_model.e4648fde.svg";